import { default as achievementsMGvCpsvk57Meta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/achievements.vue?macro=true";
import { default as dailytaskssdorLN5bEPMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/dailytasks.vue?macro=true";
import { default as earnrCnhEuQJUbMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/earn.vue?macro=true";
import { default as game_45infoG4AmC6GXMZMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/game-info.vue?macro=true";
import { default as historyt6uPv7j9sYMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/history.vue?macro=true";
import { default as index5gdcGlUsayMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/index.vue?macro=true";
import { default as invite_45friendyBqRPqYVpzMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/invite-friend.vue?macro=true";
import { default as leader_45board2SZAaXkCTRMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/leader-board.vue?macro=true";
import { default as profileCA37aaA8KoMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/profile.vue?macro=true";
import { default as shop32Vp83bh9bMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/shop.vue?macro=true";
import { default as spin_45wheelm2c6oOQSDfMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/spin-wheel.vue?macro=true";
import { default as upgradeZ3mBS05SyoMeta } from "/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/upgrade.vue?macro=true";
export default [
  {
    name: achievementsMGvCpsvk57Meta?.name ?? "achievements",
    path: achievementsMGvCpsvk57Meta?.path ?? "/achievements",
    meta: achievementsMGvCpsvk57Meta || {},
    alias: achievementsMGvCpsvk57Meta?.alias || [],
    redirect: achievementsMGvCpsvk57Meta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/achievements.vue").then(m => m.default || m)
  },
  {
    name: dailytaskssdorLN5bEPMeta?.name ?? "dailytasks",
    path: dailytaskssdorLN5bEPMeta?.path ?? "/dailytasks",
    meta: dailytaskssdorLN5bEPMeta || {},
    alias: dailytaskssdorLN5bEPMeta?.alias || [],
    redirect: dailytaskssdorLN5bEPMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/dailytasks.vue").then(m => m.default || m)
  },
  {
    name: earnrCnhEuQJUbMeta?.name ?? "earn",
    path: earnrCnhEuQJUbMeta?.path ?? "/earn",
    meta: earnrCnhEuQJUbMeta || {},
    alias: earnrCnhEuQJUbMeta?.alias || [],
    redirect: earnrCnhEuQJUbMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/earn.vue").then(m => m.default || m)
  },
  {
    name: game_45infoG4AmC6GXMZMeta?.name ?? "game-info",
    path: game_45infoG4AmC6GXMZMeta?.path ?? "/game-info",
    meta: game_45infoG4AmC6GXMZMeta || {},
    alias: game_45infoG4AmC6GXMZMeta?.alias || [],
    redirect: game_45infoG4AmC6GXMZMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/game-info.vue").then(m => m.default || m)
  },
  {
    name: historyt6uPv7j9sYMeta?.name ?? "history",
    path: historyt6uPv7j9sYMeta?.path ?? "/history",
    meta: historyt6uPv7j9sYMeta || {},
    alias: historyt6uPv7j9sYMeta?.alias || [],
    redirect: historyt6uPv7j9sYMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/history.vue").then(m => m.default || m)
  },
  {
    name: index5gdcGlUsayMeta?.name ?? "index",
    path: index5gdcGlUsayMeta?.path ?? "/",
    meta: index5gdcGlUsayMeta || {},
    alias: index5gdcGlUsayMeta?.alias || [],
    redirect: index5gdcGlUsayMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/index.vue").then(m => m.default || m)
  },
  {
    name: invite_45friendyBqRPqYVpzMeta?.name ?? "invite-friend",
    path: invite_45friendyBqRPqYVpzMeta?.path ?? "/invite-friend",
    meta: invite_45friendyBqRPqYVpzMeta || {},
    alias: invite_45friendyBqRPqYVpzMeta?.alias || [],
    redirect: invite_45friendyBqRPqYVpzMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/invite-friend.vue").then(m => m.default || m)
  },
  {
    name: leader_45board2SZAaXkCTRMeta?.name ?? "leader-board",
    path: leader_45board2SZAaXkCTRMeta?.path ?? "/leader-board",
    meta: leader_45board2SZAaXkCTRMeta || {},
    alias: leader_45board2SZAaXkCTRMeta?.alias || [],
    redirect: leader_45board2SZAaXkCTRMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/leader-board.vue").then(m => m.default || m)
  },
  {
    name: profileCA37aaA8KoMeta?.name ?? "profile",
    path: profileCA37aaA8KoMeta?.path ?? "/profile",
    meta: profileCA37aaA8KoMeta || {},
    alias: profileCA37aaA8KoMeta?.alias || [],
    redirect: profileCA37aaA8KoMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: shop32Vp83bh9bMeta?.name ?? "shop",
    path: shop32Vp83bh9bMeta?.path ?? "/shop",
    meta: shop32Vp83bh9bMeta || {},
    alias: shop32Vp83bh9bMeta?.alias || [],
    redirect: shop32Vp83bh9bMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/shop.vue").then(m => m.default || m)
  },
  {
    name: spin_45wheelm2c6oOQSDfMeta?.name ?? "spin-wheel",
    path: spin_45wheelm2c6oOQSDfMeta?.path ?? "/spin-wheel",
    meta: spin_45wheelm2c6oOQSDfMeta || {},
    alias: spin_45wheelm2c6oOQSDfMeta?.alias || [],
    redirect: spin_45wheelm2c6oOQSDfMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/spin-wheel.vue").then(m => m.default || m)
  },
  {
    name: upgradeZ3mBS05SyoMeta?.name ?? "upgrade",
    path: upgradeZ3mBS05SyoMeta?.path ?? "/upgrade",
    meta: upgradeZ3mBS05SyoMeta || {},
    alias: upgradeZ3mBS05SyoMeta?.alias || [],
    redirect: upgradeZ3mBS05SyoMeta?.redirect || undefined,
    component: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/pages/upgrade.vue").then(m => m.default || m)
  }
]